import { useState } from "react"
import { Box, Button, Stack, Typography, useTheme } from "@mui/material"
import { formatarCpf } from "@/lib/formato"
import NumericKeypad from "../../components/numeric-keypad"
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace'

interface CpfInputProps {
    onConfirmar: (cpf: string) => void
    onVoltar: () => void
    /** CPF já informado antes (ex.: identificação do totem de pedidos) — só os dígitos são usados. */
    valorInicial?: string
}

const CPF_TAMANHO = 11

export default function CpfInput({ onConfirmar, onVoltar, valorInicial }: CpfInputProps): JSX.Element {
    const theme = useTheme()
    const [cpf, setCpf] = useState(() => (valorInicial ?? '').replace(/\D/g, '').slice(0, CPF_TAMANHO))

    const handleDigito = (digito: string): void => setCpf((prev) => (prev.length >= CPF_TAMANHO ? prev : prev + digito))
    const handleApagar = (): void => setCpf((prev) => prev.slice(0, -1))
    const completo = cpf.length === CPF_TAMANHO
    const handleConfirmar = (): void => { if (completo) onConfirmar(cpf) }

    return (
        <Stack spacing={3} sx={{ alignItems: 'center', width: '100%', maxWidth: 460 }}>
            <Typography variant="h4" color="text.secondary" sx={{ fontWeight: 'bold' }}>
                Informe seu CPF:
            </Typography>

            <Box
                sx={{
                    width: '100%',
                    minHeight: 96,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '12px',
                    backgroundColor: theme.palette.personal.header,
                }}
            >
                <Typography
                    variant="h3"
                    sx={{ letterSpacing: '2px', fontWeight: cpf ? 700 : 400, color: cpf ? 'text.primary' : 'text.disabled' }}
                >
                    {cpf ? formatarCpf(cpf) : '000.000.000-00'}
                </Typography>
            </Box>

            <Box sx={{ width: '100%', height: 380 }}>
                <NumericKeypad
                    onDigito={handleDigito}
                    onApagar={handleApagar}
                    onConfirmar={handleConfirmar}
                    apagarDesabilitado={!cpf}
                    confirmarDesabilitado={!completo}
                />
            </Box>

            <Button variant="text" onClick={onVoltar} startIcon={<KeyboardBackspaceIcon />} sx={{ textTransform: 'none', fontSize: '1.1rem' }}>
                Voltar
            </Button>
        </Stack>
    )
}
